<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.polType"
                          :label="labels.polType"
                          :error-messages="errors.collect('polType')"
                          data-vv-name="polType"
                          :data-vv-as="labels.polType"
                          data-vv-scope="filters"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.polTypeDesc"
                          :label="labels.polTypeDesc"
                          :error-messages="errors.collect('polTypeDesc')"
                          data-vv-name="polTypeDesc"
                          :data-vv-as="labels.polTypeDesc"
                          data-vv-scope="filters"
                          v-validate="'max:40'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete
                          :items="polTypeAppIdList"
                          v-model="filters.polTypeAppId"
                          :label="labels.polTypeAppId"
                          item-text="label"
                          item-value="value"
                          data-vv-name="polTypeAppId"
                          :data-vv-as="labels.polTypeAppId"
                          data-vv-scope="filters"
                          :error-messages="errors.collect('polTypeAppId')"
                          v-validate="'max:8'"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.dept"
                          :label="labels.dept"
                          :error-messages="errors.collect('dept')"
                          data-vv-name="dept"
                          :data-vv-as="labels.dept"
                          data-vv-scope="filters"
                          v-validate="'max:1'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete
                          :items="booleanList"
                          v-model="filters.appShortTerm"
                          :label="labels.appShortTerm"
                          item-text="label"
                          item-value="value"
                          data-vv-name="appShortTerm"
                          :data-vv-as="labels.appShortTerm"
                          data-vv-scope="filters"
                          :error-messages="errors.collect('appShortTerm')"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.polNoForm"
                          :label="labels.polNoForm"
                          :error-messages="errors.collect('polNoForm')"
                          data-vv-name="polNoForm"
                          :data-vv-as="labels.polNoForm"
                          data-vv-scope="filters"
                          v-validate="'max:10'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="showMore">
                      <v-flex xl3 lg4 xs6>
                        <!--
                        <v-autocomplete
                          :items="defSchedFormList"
                          v-model="filters.defSchedForm"
                          :label="labels.defSchedForm"
                          item-text="label"
                          item-value="value"
                          data-vv-name="defSchedForm"
                          :data-vv-as="labels.defSchedForm"
                          data-vv-scope="filters"
                          :error-messages="errors.collect('defSchedForm')"
                          v-validate="'max:8'"
                        ></v-autocomplete>
                        -->
                        <v-text-field
                          v-model="filters.defSchedForm"
                          :label="labels.defSchedForm"
                          :error-messages="errors.collect('defSchedForm')"
                          data-vv-name="defSchedForm"
                          :data-vv-as="labels.defSchedForm"
                          data-vv-scope="filters"
                          v-validate="'max:1'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Policy Type
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-flex>
          <v-data-table
            :headers="headers"
            :items="items"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.polType }}</td>
                <td class="text-xs-left">{{ row.item.polTypeDesc }}</td>
                <td class="text-xs-left">{{ row.item.polTypeAppId }}</td>
                <td class="text-xs-left">{{ row.item.dept }}</td>
                <td class="text-xs-left">{{ formatBoolean(row.item.appShortTerm) }}</td>
                <td class="text-xs-left">{{ row.item.polNoForm }}</td>
                <td class="text-xs-left">{{ row.item.defSchedForm }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview" remove @remove="doPromptRemove" query @query="doQuery"></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the selected Policy Type?</p>
          <div class="title">{{ selectedPolType.polType }} - {{ selectedPolType.polTypeDesc }}</div>
        </confirm>
      </v-card>
    </v-flex>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { appIDDesc } from '@/const/underwriting'
import { polTypeDataMixin } from '@/mixins/params/polTypeDataMixin'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Policy Type Group',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeGrp' }
        }
      ],
      filters: {
        polType: null,
        polTypeDesc: null,
        polTypeAppId: null,
        dept: null,
        appShortTerm: null,
        polNoForm: null,
        defSchedForm: null
      },
      labels: {
        polType: 'Policy Type',
        polTypeDesc: 'Description',
        polTypeAppId: 'App ID',
        dept: 'Department',
        appShortTerm: 'Short Term',
        polNoForm: 'Policy No. Format',
        defSchedForm: 'Default Schedule Format'
      },
      headers: [
        { text: 'Policy Type', value: 'polType' },
        { text: 'Description', value: 'polTypeDesc' },
        { text: 'App ID', value: 'polTypeAppId' },
        { text: 'Department', value: 'dept' },
        { text: 'Short Term', value: 'appShortTerm' },
        { text: 'Policy No. Format', value: 'polNoForm' },
        { text: 'Default Schedule Format', value: 'defSchedForm' },
        TableConst.tableActionHeader
      ],
      showMore: false,
      totalItems: 0,
      selectedPolType: {
        polType: null,
        polTypeDesc: null
      },
      promptRemove: false,
      toogleArray: [false],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit(true)
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getAllPolType
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            const { data } = result.data
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              data.map((polType) => {
                const convertList = {
                  polType: polType.polType,
                  polTypeDesc: polType.polTypeDesc,
                  polTypeAppId: polType.polTypeAppId,
                  dept: polType.dept,
                  appShortTerm: polType.appShortTerm,
                  polNoForm: polType.polNoForm,
                  defSchedForm: polType.defSchedForm
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filters').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.polType = null
      this.filters.polTypeDesc = null
      this.filters.polTypeAppId = null
      this.filters.dept = null
      this.filters.appShortTerm = null
      this.filters.polNoForm = null
      this.filters.defSchedForm = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doReview(data) {
      if (data && data.item) {
        this.$router.push({
          name: 'polTypeDet',
          params: {
            polType: data.item.polType,
            modeQuery: false
          }
        })
      }
    },
    doQuery(data) {
      if (data && data.item) {
        this.$router.push({
          name: 'polTypeDet',
          params: {
            polType: data.item.polType,
            modeQuery: true
          }
        })
      }
    },
    doNew() {
      this.$router.push({
        name: 'polTypeDet',
        params: {
          polType: 'new'
        }
      })
    },
    async doPromptRemove(polType) {
      this.resetMessages()
      if (polType && polType.item) {
        try {
          const apiURI = this.menu.checkDelete
          if (apiURI) {
            const expand = {
              polType: polType.item.polType
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.selectedPolType.polType = polType.item.polType
            this.selectedPolType.polTypeDesc = polType.item.polTypeDesc
            this.promptRemove = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedPolType.polType) {
        const apiURI = this.menu.deletePolType
        if (apiURI) {
          const expand = {
            polType: this.selectedPolType.polType
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    formatBoolean(xBoolean) {
      return xBoolean ? 'Yes' : 'No'
    },
    schedForm(appID) {
      return appIDDesc[appID]
    }
  },
  computed: {
    menu() {
      return this.$store.state.polTypeParam.menu
    },
    booleanList() {
      return [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ]
    },
    polTypeAppIdList() {
      return [
        { label: 'CA - Cargo', value: 'CA' },
        { label: 'HE - Health', value: 'HE' },
        { label: 'HU - Hull', value: 'HU' },
        { label: 'FI - Fire', value: 'FI' },
        { label: 'MD - Maid', value: 'MD' },
        { label: 'MO - Motor', value: 'MO' },
        { label: 'PA - Personal Accident', value: 'PA' },
        { label: 'MI - Miscellaneous', value: 'MI' },
        { label: 'TR - Travel', value: 'TR' }
      ]
    },
    defSchedFormList() {
      return [
        { label: 'CA - Cargo', value: 'CA' },
        { label: 'HE - Health', value: 'HE' },
        { label: 'HU - Hull', value: 'HU' },
        { label: 'FI - Fire', value: 'FI' },
        { label: 'MO - Motor', value: 'MO' },
        { label: 'PA - Personal Accident', value: 'PA' },
        { label: 'MI - Miscellaneous', value: 'MI' }
      ]
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin, polTypeDataMixin]
}
</script>

<style>
</style>
